import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetAppFeatures } from '../../../redux/api/appConfigApi';
import { AppFeatureKey } from '../../../shared/constants';
import { Paths } from '../../../shared/paths';

export function useExercisesPage() {
  const { t, i18n } = useTranslation();
  const { data: features } = useGetAppFeatures();
  const isSharingExercisesActive = features?.find(
    (feature) => feature.key === AppFeatureKey.sharingExercises,
  )?.isActive;

  const [planDialogOpened, setPlanDialogOpen] = useState(false);

  const tabsConfig = useMemo(
    () =>
      [
        {
          label: t('exercises.publicExercises'),
          path: Paths.exercises.toPublic,
          onboardingKey: 'exercsiePage.tab.public',
        },
        {
          label: t('exercises.myExercises'),
          path: Paths.exercises.toMy,
          onboardingKey: 'exercsiePage.tab.my',
        },
        isSharingExercisesActive
          ? {
              label: t('exercises.favoriteExercises'),
              path: Paths.exercises.toFavorite,
              onboardingKey: 'exercsiePage.tab.favorite',
            }
          : null,
        isSharingExercisesActive
          ? {
              label: t('exercises.publishedByUsers'),
              path: Paths.exercises.toPublishedByUsers,
              onboardingKey: 'exercsiePage.tab.publishedByUsers',
            }
          : null,
      ].filter(Boolean),
    [t, isSharingExercisesActive, i18n.language],
  );

  return {
    tabsConfig,
    planDialogOpened,
    setPlanDialogOpen,
    isSharingExercisesActive,
  };
}
